

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _index = require('xo-models/src/shippingMethod/index');

var _index2 = require('xo-models/src/checkout/index');

require('components/xo-ui-components/src/modal/directive');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
    tag: 'xo-select-shipping-method',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        showShippingAddress: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        continueHandler: function continueHandler() {

            if (this.selectedMethod.index !== this.selectedMethod.prevIndex) {

                var selectedMethodCharges = void 0,
                    taxAmtApplied = void 0;
                this.selectedMethod.prevIndex = this.selectedMethod.index;
                selectedMethodCharges = this.response.charges[this.selectedMethod.index];
                if (this.taxComputationRequired) {
                    if (selectedMethodCharges.tax) {
                        taxAmtApplied = this.safeConvert(selectedMethodCharges.tax.total_tax.value);
                    }
                } else {
                    taxAmtApplied = this.cartAmounts.taxAmt;
                }
                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type);
                this.selectedShippingMethod = selectedMethodCharges.shipping_charge.shipping_method;
            }
            this.actions.closeModal();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.selectedMethod = {
                index: 0,
                prevIndex: 0
            };

            // Initialization
            this.taxComputationRequired = true;
            this.showModal = false;
            this.shippingMethodDisplay = 'noHighlight';
            this.addressChanged = false;

            var timer = void 0;
            this.previousCosts = {};

            var responseHasShippingCharges = function responseHasShippingCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].shipping_charge;
            };

            var responseHasTaxCharges = function responseHasTaxCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].tax;
            };

            this.safeConvert = function (value) {
                value = Number(value);
                if (isNaN(value)) {
                    throw new Error(value + ' cannot be divided');
                }
                return value / 100;
            };

            var highlight = function highlight(duration) {
                _this.shippingMethodDisplay = 'highlight';
                if (timer) {
                    _angular.$timeout.cancel(timer);
                }
                timer = (0, _angular.$timeout)(function () {
                    _this.shippingMethodDisplay = 'noHighlight';
                }, duration);
            };

            var updatePreviousCosts = function updatePreviousCosts() {
                _this.previousCosts = {};
                if (_this.models.checkoutCart.purchase.amounts.shipping) {
                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
                }
                if (_this.models.checkoutCart.purchase.amounts.tax) {
                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
                }
            };

            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
                if (newShipping !== undefined) {
                    return newShipping.amount !== _this.previousCosts.shippingAmount;
                }
                return newShipping !== _this.previousCosts.shippingAmount;
            };

            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
                if (newTax !== undefined) {
                    return newTax.amount !== _this.previousCosts.taxAmount;
                }
                return newTax !== _this.previousCosts.taxAmount;
            };

            var setToolTipMessage = function setToolTipMessage() {
                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
            };

            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod) {
                var patchShippingAmt = false,
                    patchTaxAmt = false;
                if (shippingAmt) {
                    shippingAmt = Number(shippingAmt);
                    patchShippingAmt = true;
                } else {
                    shippingAmt = 0;
                }

                if (taxAmt) {
                    taxAmt = Number(taxAmt);
                    patchTaxAmt = true;
                } else {
                    taxAmt = 0;
                }
                var shippingAmtDiff = _this.cartAmounts.shippingAmt ? shippingAmt - _this.cartAmounts.shippingAmt : shippingAmt;
                var taxAmtDiff = _this.cartAmounts.taxAmt ? taxAmt - _this.cartAmounts.taxAmt : taxAmt;
                var amountValue = {
                    'total': (_this.cartAmounts.total + shippingAmtDiff + taxAmtDiff).toFixed(2),
                    'currency': _this.currencyCode,
                    'details': {
                        'subtotal': _this.cartAmounts.subTotal.toFixed(2)
                    }
                };

                if (patchShippingAmt) {
                    amountValue.details.shipping = shippingAmt.toFixed(2);
                }
                if (patchTaxAmt) {
                    amountValue.details.tax = taxAmt.toFixed(2);
                }
                if (_this.cartAmounts.handlingAmt !== undefined) {
                    amountValue.details.handling_fee = _this.cartAmounts.handlingAmt.toFixed(2);
                }
                if (_this.cartAmounts.insuranceAmt !== undefined) {
                    amountValue.details.insurance = _this.cartAmounts.insuranceAmt.toFixed(2);
                }
                if (_this.cartAmounts.shippingDiscountAmt !== undefined) {
                    amountValue.details.shipping_discount = _this.cartAmounts.shippingDiscountAmt.toFixed(2);
                }
                if (_this.cartAmounts.discountAmt !== undefined) {
                    amountValue.details.discount = _this.cartAmounts.discountAmt.toFixed(2);
                }

                return {
                    id: _this.token,
                    patchEntities: [{
                        field: 'purchaseAmount',
                        value: amountValue
                    }, {
                        field: 'shippingMethod',
                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
                    }]
                };
            };

            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod) {
                _this.models.checkoutCart.action('patchCartData', {
                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod),
                    success: function success(result) {
                        _this.models.checkoutSession.invalidate();
                        (0, _squid.$populate)(_this, {
                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
                        }).then(function () {
                            highlight(4000);
                            if (_this.addressChanged) {
                                setToolTipMessage();
                                _this.addressChanged = false;
                            }
                            updatePreviousCosts();
                        });
                    }
                });
            };

            var setDefaultShippingMethod = function setDefaultShippingMethod() {
                _this.showShippingOptions = true;
                var chargesElement = void 0,
                    methodType = void 0,
                    taxAmtApplied = void 0;
                for (var i = 0; i < _this.response.charges.length; i++) {
                    chargesElement = _this.response.charges[i];
                    if (chargesElement.shipping_charge.default_method) {
                        _this.selectedMethod.index = i;
                        _this.selectedMethod.prevIndex = i;
                        _this.selectedShippingMethod = chargesElement.shipping_charge.shipping_method;
                        methodType = chargesElement.shipping_charge.shipping_method_type;
                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);

                        if (_this.taxComputationRequired) {
                            if (chargesElement.tax) {
                                taxAmtApplied = _this.safeConvert(chargesElement.tax.total_tax.value);
                            }
                        } else {
                            taxAmtApplied = _this.cartAmounts.taxAmt;
                        }
                        break;
                    }
                }
                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType);
            };

            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
            };

            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {

                var applicableShippingAmt = void 0,
                    applicableTaxAmt = void 0;
                // shipping calculation

                if (_this.showShippingAddress) {
                    if (!_this.response.profile_override_allowed) {
                        if (responseHasShippingCharges()) {
                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
                            return;
                        }
                    } else if (_this.cartAmounts.shippingAmt !== undefined) {
                        applicableShippingAmt = _this.cartAmounts.shippingAmt;
                    } else if (responseHasShippingCharges()) {
                        setDefaultShippingMethod();
                        return;
                    }
                } else if (_this.response.profile_override_allowed) {
                    if (_this.cartAmounts.shippingAmt !== undefined) {
                        applicableShippingAmt = _this.cartAmounts.shippingAmt;
                    }
                }

                // tax calculation
                if (_this.taxComputationRequired) {
                    if (responseHasTaxCharges()) {
                        applicableTaxAmt = _this.safeConvert(_this.response.charges[0].tax.item_tax.value);
                        if (_this.response.charges[0].tax.shipping_tax && applicableShippingAmt) {
                            applicableTaxAmt += Number(_this.response.charges[0].tax.rate) * applicableShippingAmt / (100 * 1000);
                        }
                    }
                } else {
                    applicableTaxAmt = _this.cartAmounts.taxAmt;
                }
                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
                }
            };

            this.getShippingMethods = function () {
                _this.showShippingOptions = false;
                _this.selectedShippingMethod = '';
                _this.shippingAmtApplied = 0;
                _this.response = {};

                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();
                _this.shippingMethods = new _index.$ShippingMethodModel({
                    'address': shippingAddress,
                    'cart_weight': _this.cartWeight,
                    'discount': _this.cartDiscount,
                    'item_list': _this.models.checkoutCart.purchase.items,
                    'tax_computation_required': _this.taxComputationRequired,
                    'merchant_id': _this.models.checkoutPayee.merchant.id,
                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry
                });
                _logger.$logger.info('calculate_shipping_charges_call');
                _this.shippingMethods.save({
                    data: _this.shippingMethods,
                    success: function success(result) {
                        _this.response = result;
                        processShippingAndTaxResponse();
                    }
                });
            };
        },
        populate: function populate() {
            var _this2 = this;

            var set = function set(key, value) {
                if (value) {
                    _this2.cartAmounts[key] = Number(value.amount);
                }
            };

            function hasAddressChanged(newValue, oldValue) {
                // only these values determine if the shiptax service needs to be called again
                return newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;
            }

            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
            this.cartAmounts = {};
            this.cartWeight = {};
            this.cartDiscount = {};
            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
            set('total', this.models.checkoutCart.purchase.amounts.total);
            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
            this.previousCosts = {
                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
            };

            if (this.models.checkoutCart.cartWeight) {
                if (this.models.checkoutCart.cartWeight.value) {
                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
                }
                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
            }

            if (this.models.checkoutCart.purchase.amounts.discount) {
                this.cartDiscount.value = Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2);
                this.cartDiscount.currency_code = this.currencyCode;
            }

            if (this.cartAmounts.taxAmt !== undefined) {
                this.taxComputationRequired = false;
            }

            if (this.showShippingAddress) {
                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
                    if (hasAddressChanged(newValue, oldValue)) {
                        _this2.addressChanged = true;
                        _this2.getShippingMethods();
                    }
                });
            }
            this.getShippingMethods();
        }
    }
});


_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_index.$ShippingMethodModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutShippingAddressesModel;

_logger.$logger;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/select-shipping-method/directive.js
 ** module id = 364
 ** module chunks = 1
 **/